var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "basicForm",
      attrs: {
        size: "small",
        "label-position": "top",
        rules: _vm.rules,
        model: _vm.paramsForm,
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.ContractNumber"),
                    prop: "contractNo",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.paramsForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.paramsForm, "contractNo", $$v)
                      },
                      expression: "paramsForm.contractNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.CustomerName"),
                    prop: "customerId",
                  },
                },
                [
                  _c("QueryCustomerCmp", {
                    attrs: { val: _vm.paramsForm.customerId, type: 1 },
                    on: {
                      change: function (val) {
                        return (_vm.paramsForm.customerId = val)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.ContractType"),
                    prop: "type",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.paramsForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramsForm, "type", $$v)
                        },
                        expression: "paramsForm.type",
                      },
                    },
                    _vm._l(_vm.CONTRACT_TYPE, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("basicData.PaymentTerms") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                      clearable: "",
                    },
                    on: { input: _vm.handlePaymentDaysInput },
                    model: {
                      value: _vm.paramsForm.paymentDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.paramsForm, "paymentDays", _vm._n($$v))
                      },
                      expression: "paramsForm.paymentDays",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.ReconciliationStatus"),
                    prop: "reconciliationStatus",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.paramsForm.reconciliationStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramsForm, "reconciliationStatus", $$v)
                        },
                        expression: "paramsForm.reconciliationStatus",
                      },
                    },
                    _vm._l(_vm.ACCOUNT_STATUS, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.desc, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.ContractDate"),
                    prop: "time",
                  },
                },
                [
                  _c("el-date-picker", {
                    style: { width: "100%" },
                    attrs: {
                      type: "daterange",
                      "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                      "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.paramsForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.paramsForm, "time", $$v)
                      },
                      expression: "paramsForm.time",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.ContractStatus"),
                    prop: "status",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.paramsForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramsForm, "status", $$v)
                        },
                        expression: "paramsForm.status",
                      },
                    },
                    _vm._l(_vm.CONTRACT_STATUS, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("basicData.remark") } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.paramsForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.paramsForm, "remark", $$v)
                      },
                      expression: "paramsForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }